import { addStateEventListener } from '@nx/state';

import { trackingShowInExploreEvent, userQueryTypes } from '../../services/tracking';
import { getIsInitialisationCompleted } from '../app/appDuck';
import { setCurrentPerspective } from '../rootReducer';
import { setStartWithProvidedGraph } from '../scene/scene';
import { refreshScenes } from '../scene/sceneThunks';
import type { AppDispatch, RootState } from '../types';
import { getNextActivePerspectiveId } from './utils';

export const initiateSendGraphToExploreSync = (getState: () => RootState, dispatch: AppDispatch) => {
  addStateEventListener('sendGraphToExplore', async (listenerApi) => {
    const state = getState();
    const isInitialisationCompleted = getIsInitialisationCompleted(state);
    const actionPayload = (listenerApi.action as { payload?: any })?.payload;
    if (actionPayload && actionPayload.nodes) {
      const { nodes, relationships } = actionPayload;
      trackingShowInExploreEvent(userQueryTypes.showFromQuery, nodes.length ?? 0, relationships.length ?? 0);
      dispatch(setStartWithProvidedGraph({ nodes, relationships }));
      if (isInitialisationCompleted) {
        const nextActivePerspectiveId = getNextActivePerspectiveId(getState());
        dispatch(setCurrentPerspective(nextActivePerspectiveId));
        void dispatch(refreshScenes());
      }
    }
  });
};
